const SET_THEME = 'SET_THEME'
const SET_VIEWHEIGHT = 'SET_VIEWHEIGHT'
const SET_VIEWWIDTH = 'SET_VIEWWIDTH'
const SET_VIEWBACKGROUNDCOLOR = 'SET_VIEWBACKGROUNDCOLOR'
const SET_VIEWBACKGROUNDIMAGE = 'SET_VIEWBACKGROUNDIMAGE'
const SET_VIEWZOOM = 'SET_VIEWZOOM'
const ADD_PART = 'ADD_PART'
const DEL_PART = 'DEL_PART'
const UPDATE_PART = 'UPDATE_PART'
const SET_PARTS = 'SET_PARTS'

export { SET_THEME, SET_VIEWHEIGHT, SET_VIEWWIDTH, SET_VIEWBACKGROUNDCOLOR, SET_VIEWBACKGROUNDIMAGE, SET_VIEWZOOM, ADD_PART, DEL_PART, UPDATE_PART, SET_PARTS}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js